import * as api from '../salesAdminApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchSaSalesDistricts, salesAdminActionCreators, SalesAdminActionKeys } from '..';
import { ISalesDistrict } from '../../lookups';

function* fetchSaSalesDistrictsSaga(action: FetchSaSalesDistricts) {
  yield put(salesAdminActionCreators.toggleLoading('salesDistrict'));
  const sds: ISalesDistrict[] = yield call(api.FetchSalesDistricts);

  yield put(salesAdminActionCreators.setSalesDistricts(sds));

  yield put(salesAdminActionCreators.toggleLoading('salesDistrict'));
}

export function* watchFetchSaSalesDistricts() {
  yield takeEvery(SalesAdminActionKeys.FETCH_SA_SALES_DISTS, fetchSaSalesDistrictsSaga);
}
